/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット画面
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-chat-window">

  <el-header class="header-area" :class="{'window-move-drag-handle': $config.fastchatFrameConfig.draggable}" height="auto" @mousedown.native="dragStart">
    <el-container>
      <el-main class="header-main-area">
        <div class="header-main-content">
          <div :class="[iconChatTitleClass]"></div>
          <div class="header-main-label">{{$t('チャットで質問する')}}</div>
        </div>
      </el-main>
      <el-aside width="auto" class="close-button-wrapper">
        <el-button class="minimize-button" icon="el-icon-minus" ref="minimizeButton" v-show="isShowMinimizeButton" @mousedown.prevent="" @click="doMinimize" :title="$t('チャットを最小化する')"></el-button>
        <el-button class="close-button" icon="el-icon-close" ref="closeButton" v-show="isShowCloseButton" @mousedown.prevent="" @click="doClose" :title="$t('チャットを終了する')" :disabled="waitingChatReceive"></el-button>
        <el-dropdown @command="doTestMenu" v-show="isShowTestMenuButton">
          <el-button class="close-button" icon="el-icon-menu" ref="testMenuButton" @mousedown.prevent="" :title="'テストメニュー'"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="addConfirmMessage">質問メッセージを追加</el-dropdown-item>
            <el-dropdown-item command="addSwitchConfirmMessage">質問メッセージ（スイッチ）を追加</el-dropdown-item>
            <el-dropdown-item command="addImageMessage">画像メッセージを追加</el-dropdown-item>
            <el-dropdown-item command="addButtonListMessage">ボタン一覧メッセージを追加</el-dropdown-item>
            <el-dropdown-item command="showSuggest">サジェストを表示する</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-aside>
    </el-container>
  </el-header>

  <el-container class="fc-chat-empty-pane" v-show="isShowFcChatEmptyPane">
    <el-main class="main-area">
    </el-main>
  </el-container>
  <fc-chat-join-pane ref="chatJoinPane" v-show="isShowFcChatJoinPane" @chatJoin="chatJoinHandler" @chatWindowClose="chatWindowCloseHandler" />
  <fc-chat-main-pane ref="chatMainPane" v-show="isShowFcChatMainPane" @sendMessage="sendMessageHandler" @addNewFhMessage="addNewFhMessageHandler" @reconnectChat="reconnectChatHandler" @messageTyping="sendFcMessageTypingHandler" @waitChatReceive="waitChatReceiveHandler"
    @suggestion="suggestionHandler" @openSurvey="openSurveyHandler" @updateDownloadStatus="updateDownloadStatusHandler" :waitingChatReceive="waitingChatReceive" :receptionMode="receptionMode" :useSuggestion="useSuggestion" />

</el-container>
</template>

<script>
import {
  Container,
  Aside,
  Main,
  Header,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Loading
} from 'element-ui'
import FcChatMainPane from './chatMain/FcChatMainPane'
import FcChatJoinPane from './chatJoin/FcChatJoinPane'
import WindowUtil from '@/utils/WindowUtil'
import DialogUtil from '@/utils/DialogUtil'
import ChatMessageConst from '@/constants/ChatMessageConst'
import CommonConst from '@/constants/CommonConst'
import SockJS from 'sockjs-client'
import FastchatStateManager from '@/utils/FastchatStateManager'

export default {
  name: 'FcChatWindow',
  components: {
    'el-container': Container,
    'el-aside': Aside,
    'el-main': Main,
    'el-header': Header,
    'el-button': Button,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem,
    FcChatMainPane,
    FcChatJoinPane
  },
  data() {
    return {
      /**
       * チャット開始パネルを表示するか
       * @type {Boolean}
       * @default false
       */
      visibledFcChatEmptyPane: false,
      /**
       * チャット開始パネルを表示するか
       * @type {Boolean}
       * @default false
       */
      visibledFcChatJoinPane: false,
      /**
       * チャットメインパネルを表示するか
       * @type {Boolean}
       * @default false
       */
      visibledFcChatMainPane: false,

      /**
       * チャット接続
       */
      chatConnection: null,

      /**
       * 読み込み中表示インスタンス
       */
      loadingInstance: null,

      /**
       * 「チャット終了」のチャット配信を受信済みか
       * @type {Boolean}
       * @default false
       */
      receivedChatEnd: false,

      /**
       * 最後にチャット通信した時間
       * @type {[Date]}
       */
      lastChatConnectionTime: null,

      /**
       * 無効なチャット接続を切断するinterval
       */
      checkChatConnectionInterval: null,

      /**
       * 対象コール特定キー
       */
      callSpecificKey: null,

      /**
       * 応対モード
       * @type {String} bot or operator
       */
      receptionMode: null,

      /**
       * チャット配信待ちか
       * @type {Boolean}
       */
      waitingChatReceive: false,

      /**
       * 質問内容のサジェストを利用するか
       * @type {Boolean}
       */
      useSuggestion: false

    }
  },
  computed: {
    /**
     * チャット開始パネルを表示するか
     * @return {Boolean}
     */
    isShowFcChatEmptyPane() {
      return this.visibledFcChatEmptyPane
    },
    /**
     * チャット開始パネルを表示するか
     * @return {Boolean}
     */
    isShowFcChatJoinPane() {
      return this.visibledFcChatJoinPane
    },
    /**
     * チャットメインパネルを表示するか
     * @return {Boolean}
     */
    isShowFcChatMainPane() {
      return this.visibledFcChatMainPane
    },
    /**
     * チャット接続しているか
     * @return {Boolean}
     */
    isChatConected() {
      return this.chatConnection != null && this.chatConnection.readyState === SockJS.OPEN
    },
    /**
     * 読み込み中か
     * @return {Boolean}
     */
    isLoading() {
      return this.loadingInstance != null
    },
    /**
     * 最小化ボタンを表示するか
     * @return {Boolean}
     */
    isShowMinimizeButton() {
      return !WindowUtil.isSeparateWindow() && !this.receivedChatEnd && (this.isShowFcChatMainPane || this.isShowFcChatJoinPane)
    },
    /**
     * 閉じるボタンを表示するか
     * @return {Boolean}
     */
    isShowCloseButton() {
      return WindowUtil.isSeparateWindow() || this.isShowFcChatMainPane
    },
    /**
     * タイトルバーのアイコンクラスを取得します。
     * @return {String}
     */
    iconChatTitleClass() {
      if (this.receptionMode === ChatMessageConst.RECEPTION_MODE_AUTO) {
        return 'icoChatTitleByBotReception'
      } else {
        return 'icoChatTitle'
      }
    },
    /**
     * テストメニューボタンを表示するか
     * @return {Boolean}
     */
    isShowTestMenuButton() {
      return this.$config['_testMode'] && this.isShowFcChatMainPane
    }
  },
  methods: {
    /**
     * チャット開始パネルを表示する
     */
    showFcChatEmptyPane() {
      this.visibledFcChatEmptyPane = true
      this.visibledFcChatJoinPane = false
      this.visibledFcChatMainPane = false
    },
    /**
     * チャット開始パネルを表示する
     */
    showFcChatJoinPane() {
      this.visibledFcChatEmptyPane = false
      this.visibledFcChatJoinPane = true
      this.visibledFcChatMainPane = false
    },
    /**
     * チャットメインパネルを表示する
     */
    showFcChatMainPane() {
      this.visibledFcChatEmptyPane = false
      this.visibledFcChatJoinPane = false
      this.visibledFcChatMainPane = true
      FastchatStateManager.changeStarted()
    },
    /**
     * 「チャットを始める」処理
     * @param {data} fastchatUserInfo チャット情報
     */
    chatStart(fastchatUserInfo) {
      this.showLoading()
      if (this.isChatConected) {
        // 強制的にチャット接続を切断します
        this.closeChatConnection()
      }
      // 「チャット開始」を送信
      this.sendChatConnection({
        'messageType': ChatMessageConst.MESSAGE_EVENT_TYPE_CHAT_START,
        'fastchatUserInfo': fastchatUserInfo
      }).catch(error => {
        console.error(error)
        this.closeChatConnection()
        this.closeLoading()
        DialogUtil.showErrorDialog('E0002', _ => {
          if (this.isShowFcChatEmptyPane) {
            this.$emit('chatWindowClose')
          }
        })
      })
    },
    /**
     * 読み込み中表示
     */
    showLoading() {
      this.closeLoading()
      if (this.$refs['chatJoinPane']) {
        this.$refs['chatJoinPane'].disabled = true
      }
      if (this.$refs['chatMainPane']) {
        this.$refs['chatMainPane'].disabled = true
      }

      this.loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    /**
     * 読み込み中表示を解除
     */
    closeLoading() {
      if (this.loadingInstance != null) {
        this.loadingInstance.close()
        this.loadingInstance = null
      }
      if (this.$refs['chatJoinPane']) {
        this.$refs['chatJoinPane'].disabled = false
      }
      if (this.$refs['chatMainPane']) {
        this.$refs['chatMainPane'].disabled = false
      }
    },
    /**
     * 送信メッセージのパラメータを取得します。
     * @param  {[Object]} param
     * @param  {[boolean]} ignoreParamLastSnsMessageIdAndFastchatState
     * @return {[Object]}
     */
    setupSendChatMessageParam(param, ignoreParamLastSnsMessageIdAndFastchatState) {
      param = param || {}
      param['fastchatWindowSettingId'] = this.$config['_fastchatWindowSettingId']
      if (!ignoreParamLastSnsMessageIdAndFastchatState) {
        param['lastSnsMessageId'] = this.$refs['chatMainPane'].getLastSnsMessageId()
        param['fastchatState'] = FastchatStateManager.getFastchatState()
      }
      const splitPath = location.pathname.split('/')
      if (splitPath.length > 3) {
        param['sitePath'] = splitPath[splitPath.length - 4]
      }
      return param
    },
    /**
     * チャット接続で送信します。
     * @param  {[Object]} param
     * @param  {[boolean]} ignoreParamLastSnsMessageIdAndFastchatState
     * @param  {[boolean]} skipConnectionCheck
     * @return {[Promise]}
     */
    sendChatConnection(param, ignoreParamLastSnsMessageIdAndFastchatState, skipConnectionCheck) {
      if (skipConnectionCheck) {
        return new Promise((resolve) => {
          try {
            this.chatConnection.send(JSON.stringify(this.setupSendChatMessageParam(param, ignoreParamLastSnsMessageIdAndFastchatState)))
          } catch (e) {
            // 何もしない
          } finally {
            resolve()
          }
        })
      } else {
        return new Promise((resolve, reject) => {
          this.prepareChatConnection().then(connected => {
            if (connected) {
              try {
                this.chatConnection.send(JSON.stringify(this.setupSendChatMessageParam(param, ignoreParamLastSnsMessageIdAndFastchatState)))
              } catch (error) {
                reject(error)
              }
            }
            resolve()
          })
        })
      }
    },
    /**
     * チャット接続準備処理
     * @return {Promise}
     */
    prepareChatConnection() {
      let preparing = true
      return new Promise((resolve) => {
        if (this.isChatConected) {
          resolve(true)
          return
        }
        this.closeChatConnection()
        this.chatConnection = new SockJS(this.$config.chatServer)

        const initializedConnectionFunc = (event) => {
          const eventData = JSON.parse(event.data)
          if (eventData.messageType === ChatMessageConst.INITIALIZED_CHAT_CONNECTION) {
            this.chatConnection.removeEventListener('message', initializedConnectionFunc)
            const retryFunc = e => {
              if (preparing && window.document.readyState === 'complete') {
                this.chatStart()
              }
            }
            this.chatConnection.onerror = retryFunc
            this.chatConnection.onclose = retryFunc
            this.lastChatConnectionTime = new Date()
            this.startCheckChatConnection()
            resolve(true)
          }
        }

        const openFunc = _ => {
          this.chatConnection.onheartbeat = _ => {
            this.lastChatConnectionTime = new Date()
          }
          this.$refs['chatMainPane'].unavailableChatConnection = false
          this.chatConnection.removeEventListener('open', openFunc)
          this.chatConnection.addEventListener('message', initializedConnectionFunc)
          this.chatConnection.send(JSON.stringify({
            'messageType': ChatMessageConst.INIT_CHAT_CONNECTION,
            'fastchatWindowSettingId': this.$config['_fastchatWindowSettingId']
          }))
        }
        this.chatConnection.addEventListener('open', openFunc)

        const closeFunc = _ => {
          this.chatConnection.removeEventListener('open', openFunc)
          this.chatConnection.removeEventListener('message', initializedConnectionFunc)
          this.closeChatConnection(true)
          resolve(false)
        }
        this.chatConnection.onerror = closeFunc
        this.chatConnection.onclose = closeFunc

        this.chatConnection.onmessage = this.chatMessageHandler
      }).then(result => {
        preparing = false
        return new Promise((resolve) => {
          resolve(result)
        })
      })
    },
    /**
     * 無効なチャット接続を切断するintervalを開始します。
     */
    startCheckChatConnection() {
      this.stopCheckChatConnection()
      if (this.$config.availableChatConnectionIntervalTime > 0) {
        this.checkChatConnectionInterval = setInterval(this.closeUnavailableChatConnection, 1000)
      }
    },
    /**
     * 無効なチャット接続を切断するintervalを停止します。
     */
    stopCheckChatConnection() {
      if (this.checkChatConnectionInterval != null) {
        clearInterval(this.checkChatConnectionInterval)
        this.checkChatConnectionInterval = null
      }
    },
    /**
     * 無効なチャット接続を切断します。
     */
    closeUnavailableChatConnection() {
      if (!this.isAvailableChatConnection() && this.chatConnection != null) {
        this.closeChatConnection(true)
      }
    },
    /**
     * チャット接続が有効か
     * @return {[type]} [description]
     */
    isAvailableChatConnection() {
      return this.chatConnection != null && this.lastChatConnectionTime != null && new Date().getTime() - this.lastChatConnectionTime.getTime() <= this.$config.availableChatConnectionIntervalTime
    },
    /**
     * チャット接続のメッセージ処理
     * @param  {[type]} event [description]
     */
    chatMessageHandler(event) {
      this.lastChatConnectionTime = new Date()
      const eventData = JSON.parse(event.data)
      if (eventData.callSpecificKey) {
        this.callSpecificKey = eventData.callSpecificKey
      }
      this.waitingChatReceive = false
      if (eventData.messageType === ChatMessageConst.MESSAGE_TYPE_CHAT_START) {
        this.receptionMode = eventData.receptionMode || ChatMessageConst.RECEPTION_MODE_MANUAL
        this.useSuggestion = eventData.useSuggestFlg === CommonConst.FLG_ON
        this.receivedChatEnd = false
        this.$refs['chatMainPane'].refreshMessageList(eventData.fastchatMessageList)
        this.closeLoading()
        if (!WindowUtil.isSeparateWindow() && FastchatStateManager.isSuspended()) {
          this.$emit('chatWindowMinimize')
        } else if (!WindowUtil.isSeparateWindow() && FastchatStateManager.isSuspendedWithNewNoticed()) {
          this.$emit('chatWindowMinimize')
          this.$emit('addNewFhMessage')
        } else {
          this.showFcChatMainPane()
        }
      } else if (eventData.messageType === ChatMessageConst.MESSAGE_TYPE_ADD_MESSAGE) {
        this.$refs['chatMainPane'].addMessage(eventData.fastchatMessageList)
      } else if (eventData.messageType === ChatMessageConst.MESSAGE_TYPE_SYSTEM_ERROR) {
        DialogUtil.showErrorDialog('E0003', _ => {
          if (this.isShowFcChatEmptyPane) {
            this.$emit('chatWindowClose')
          }
        })
        this.closeLoading()
      } else if (eventData.messageType === ChatMessageConst.MESSAGE_TYPE_SEND_FILE_ERROR) {
        DialogUtil.showInfoDialog(this.$t('ファイルの送信に失敗しました。'))
      } else if (eventData.messageType === ChatMessageConst.MESSAGE_TYPE_CHAT_END && !FastchatStateManager.isEnded()) {
        this.closeLoading()
        this.showFcChatMainPane()
                let replyMessage = this.$t('チャットは終了しました。')
        if (eventData.fastchatMessageList != null) {
          for (let replyMessageList of eventData.fastchatMessageList) {
            if (replyMessageList.snsMessageId == null) {
              replyMessage = replyMessageList.message
              eventData.fastchatMessageList = null
            }
          }
        }
        this.$refs['chatMainPane'].addMessage(eventData.fastchatMessageList)
        this.receivedChatEnd = true
        this.$emit('chatEnd')
        this.$refs['chatMainPane'].disabled = true
        this.closeChatConnection()
        FastchatStateManager.changeEnded()
        this.$refs['chatMainPane'].addClientSystemMessage(this.$t('チャットは終了しました。'))
        DialogUtil.close()
        setTimeout(_ => {
          DialogUtil.showInfoDialog(replyMessage)
        }, 0)
      } else if (eventData.messageType === ChatMessageConst.MESSAGE_TYPE_FH_TYPING) {
        this.$refs['chatMainPane'].showFhMessageTypingLabel()
      } else if (eventData.messageType === ChatMessageConst.MESSAGE_TYPE_SUGGEST) {
        this.$refs['chatMainPane'].showSuggestList(eventData.suggestList)
      } else if (eventData.messageType === ChatMessageConst.MESSAGE_TYPE_CHAT_STAFF_READED) {
        this.$refs['chatMainPane'].updateMessageStaffReaded(eventData.fastchatMessageList)
      } else if (eventData.messageType === ChatMessageConst.MESSAGE_EVENT_TYPE_UNDO_SEND_ATTACH) {
        this.$refs['chatMainPane'].removeMessageUndoSendAttach(eventData.fastchatMessageList)
      }
      this.updateWaitingChatReceive()
    },
    /**
     * チャット配信待ち状態を更新します。
     */
    updateWaitingChatReceive() {
      const lastSnsMessageOption = this.$refs['chatMainPane'].getLastSnsMessageOption()
      let waitChatReceive = false
      if (lastSnsMessageOption != null) {
        waitChatReceive = lastSnsMessageOption.waitChatReceive || false
      }
      this.waitingChatReceive = waitChatReceive
    },
    /**
     * チャット接続を切断します。
     */
    closeChatConnection(unavailableChatConnection, errorCode) {
      this.stopCheckChatConnection()
      this.waitingChatReceive = false
      if (this.chatConnection != null) {
        this.chatConnection.onclose = null
        this.chatConnection.onerror = null
        this.chatConnection.onmessage = null
        this.chatConnection.onheartbeat = null
        this.chatConnection.close()
        this.chatConnection = null
      }
      if (unavailableChatConnection) {
        errorCode = errorCode || 'E0002'
        this.$refs['chatMainPane'].unavailableChatConnection = true
        this.closeLoading()
        DialogUtil.showErrorDialog(errorCode, _ => {
          if (this.isShowFcChatEmptyPane) {
            this.$emit('chatWindowClose')
          }
        })
      }
    },
    /**
     * チャット開始イベントハンドラ
     * @param {data} fastchatUserInfo チャット情報
     */
    chatJoinHandler(fastchatUserInfo) {
      this.chatStart(fastchatUserInfo)
    },
    /**
     * メッセージ送信イベントハンドラ
     * @param  {data} fastchatSendMessage 送信メッセージ情報
     * @param  {string} messageEventType メッセージ種別
     */
    sendMessageHandler(fastchatSendMessage, messageEventType) {
      this.sendMessage(fastchatSendMessage, messageEventType)
    },
    /**
     * メッセージ入力中送信イベントハンドラ
     */
    sendFcMessageTypingHandler() {
      this.sendFcMessageTyping()
    },
    /**
     * 「メッセージ送信」処理
     * @param {data} fastchatSendMessage 送信メッセージ情報
     * @param  {string} messageEventType メッセージ種別
     */
    sendMessage(fastchatSendMessage, messageEventType) {
      messageEventType = messageEventType || ChatMessageConst.MESSAGE_EVENT_TYPE_SEND_MESSAGE
      this.$refs['chatMainPane'].requesting = true
      // 「メッセージ送信」を送信
      this.sendChatConnection({
        'messageType': messageEventType,
        fastchatSendMessage: fastchatSendMessage
      }).then(_ => {
        this.$refs['chatMainPane'].clearSendMessageForm()
      }).catch(error => {
        console.error(error)
        this.closeChatConnection(true)
      }).finally(_ => {
        this.$refs['chatMainPane'].requesting = false
      })
    },
    /**
     * 「メッセージ入力中送信」処理
     */
    sendFcMessageTyping() {
      // 「メッセージ入力中送信」を送信
      this.sendChatConnection({
        'messageType': ChatMessageConst.MESSAGE_EVENT_TYPE_MESSAGE_TYPING
      }, true, true)
    },
    /**
     * チャットを終了する
     */
    doClose() {
      if (!this.isShowFcChatMainPane) {
        this.close()
        return
      }
      DialogUtil.showConfirmDialog(this.$t('チャットを終了しますか?'), _ => {
        // 終了メッセージを追加
        this.$refs['chatMainPane'].addClientSystemMessage(this.$t('チャットは終了しました。'))
        this.close()
      })
    },
    /**
     * 「チャット終了」処理
     */
    close() {
      const openedSurvey = FastchatStateManager.isOpenedSurvey()
      FastchatStateManager.clearOpenedSurvey()
      if (WindowUtil.isSeparateWindow()) {
        if (this.isShowFcChatMainPane) {
          this.showLoading()
          // チャット画面クローズ処理
          let closeFcChatMainFunc = _ => {
            this.closeLoading()
            // フォームを非活性に
            this.$refs['chatMainPane'].disabled = true
            // チャット切断
            this.closeChatConnection()
            if (!openedSurvey && this.callSpecificKey != null) {
              if (this.$config.webFormSettingId != null) {
                WindowUtil.openWebFormWindow(this.callSpecificKey)
                window.close()
              } else if (this.$config.surveyWindowConfig.useSurveyWindow) {
                DialogUtil.showFcSurveyDialog(this.callSpecificKey, _ => {
                  window.close()
                })
              } else {
                window.close()
              }
            } else {
              window.close()
            }
          }

          if (!this.receivedChatEnd) {
            FastchatStateManager.changeEnded()
            // 「チャット終了」を送信
            this.sendChatConnection({
              'messageType': ChatMessageConst.MESSAGE_EVENT_TYPE_CHAT_END
            }, true, true).finally(_ => {
              closeFcChatMainFunc()
            })
          } else {
            closeFcChatMainFunc()
          }
        } else {
          window.close()
        }
      } else {
        if (this.isShowFcChatMainPane) {
          this.showLoading()
          // チャット画面クリア処理
          const clearFcChatMainFunc = _ => {
            // チャットメインパネルをクリア
            this.$refs['chatMainPane'].clearSendMessageForm()
            this.$refs['chatMainPane'].refreshMessageList()
            this.$refs['chatMainPane'].clearFhMessageTyping()
            FastchatStateManager.clearLastNewFhMessageSnsMessageId()
            this.callSpecificKey = null
            // 「チャットで質問する」ボタンに表示切替
            this.$emit('chatWindowClose')
          }
          // チャット画面クローズ処理
          const closeFcChatMainFunc = _ => {
            this.closeLoading()
            // フォームを非活性に
            this.$refs['chatMainPane'].disabled = true
            // チャット切断
            this.closeChatConnection()
            if (!openedSurvey && this.callSpecificKey != null) {
              if (this.$config.webFormSettingId != null) {
                WindowUtil.openWebFormWindow(this.callSpecificKey)
                clearFcChatMainFunc()
              } else if (this.$config.surveyWindowConfig.useSurveyWindow) {
                DialogUtil.showFcSurveyDialog(this.callSpecificKey, clearFcChatMainFunc)
              } else {
                clearFcChatMainFunc()
              }
            } else {
              clearFcChatMainFunc()
            }
          }

          if (!this.receivedChatEnd) {
            FastchatStateManager.changeEnded()
            // 「チャット終了」を送信
            this.sendChatConnection({
              'messageType': ChatMessageConst.MESSAGE_EVENT_TYPE_CHAT_END
            }, true, true).finally(_ => {
              closeFcChatMainFunc()
            })
          } else {
            closeFcChatMainFunc()
          }
        } else {
          // 「チャットで質問する」ボタンに表示切替
          this.$emit('chatWindowClose')
        }
      }
    },
    /**
     * チャットを最小化する
     */
    doMinimize() {
      if (this.isShowFcChatMainPane) {
        FastchatStateManager.changeSuspended()
        // 「チャットを再開する」ボタンに表示切替
        this.$emit('chatWindowMinimize')
      } else {
        // 「チャットで質問する」ボタンに表示切替
        this.$emit('chatWindowClose')
      }
    },
    /**
     * メッセージ一覧を末尾までスクロールする
     */
    lastScrollMessageList() {
      this.$refs['chatMainPane'].lastScrollMessageList()
    },

    /**
     * SNSメッセージ番号のメッセージまでスクロールする
     * @param  {Number} snsMessageId SNSメッセージ番号
     * @param  {boolean} skipCloseNewFhMessage 新着メッセージポップアップをクローズしない
     */
    scrollMessageListBySnsMessageId(snsMessageId, skipCloseNewFhMessage) {
      this.$refs['chatMainPane'].scrollMessageListBySnsMessageId(snsMessageId, skipCloseNewFhMessage)
    },

    /**
     * 新着メッセージイベントハンドラ
     */
    addNewFhMessageHandler() {
      this.$emit('addNewFhMessage')
    },
    /**
     * ドラッグ開始処理
     * @param  {Event} event マウスイベント
     */
    dragStart(event) {
      if (event.target !== this.$refs.closeButton.$el && event.target.parentNode !== this.$refs.closeButton.$el &&
        event.target !== this.$refs.minimizeButton.$el && event.target.parentNode !== this.$refs.minimizeButton.$el &&
        event.target !== this.$refs.testMenuButton.$el && event.target.parentNode !== this.$refs.testMenuButton.$el
      ) {
        event.preventDefault()
        WindowUtil.postDragStartMessageToParent(event)
      }
    },
    /**
     * チャット画面クローズイベントハンドラ
     */
    chatWindowCloseHandler() {
      this.$emit('chatWindowClose')
    },

    /**
     * 再接続イベントハンドラ
     * @return {[type]} [description]
     */
    reconnectChatHandler() {
      this.reconnectChat()
    },
    /**
     * 「再接続」処理
     */
    reconnectChat() {
      this.showLoading()
      this.$refs['chatMainPane'].requesting = true
      // 「再接続」を送信
      this.sendChatConnection({
        'messageType': ChatMessageConst.MESSAGE_EVENT_TYPE_CHAT_RECONNECT
      }).catch(error => {
        console.error(error)
        DialogUtil.showErrorDialog('E0002')
      }).finally(_ => {
        this.closeLoading()
        this.$refs['chatMainPane'].requesting = false
        this.updateWaitingChatReceive()
      })
    },
    /**
     * チャット配信待ち処理
     */
    waitChatReceiveHandler() {
      this.waitingChatReceive = true
    },

    /**
     * サジェストイベントハンドラ
     *
     * @param {String} suggestTargetKeyword
     */
    suggestionHandler(suggestTargetKeyword) {
      // 「サジェスト」を送信
      this.sendChatConnection({
        'messageType': ChatMessageConst.MESSAGE_EVENT_TYPE_SUGGESTIONS,
        fastchatSendMessage: {
          messageText: suggestTargetKeyword
        }
      }, true, true)
    },

    /**
     * 「アンケートに答える」処理
     */
    openSurveyHandler() {
      if (this.callSpecificKey != null && (this.$config.surveyWindowConfig.useSurveyWindow || this.$config.webFormSettingId != null)) {
        // アンケート済みを記録
        FastchatStateManager.setOpendSurvey()
        // アンケート画面を開く
        if (this.$config.webFormSettingId != null) {
          WindowUtil.openWebFormWindow(this.callSpecificKey)
        } else if (this.$config.surveyWindowConfig.useSurveyWindow) {
          DialogUtil.showFcSurveyDialog(this.callSpecificKey, null, this.$t('キャンセル'))
        }
      }
    },

    /**
     * テストメニュー処理
     */
    doTestMenu(command) {
      const lastSnsMessageId = this.$refs['chatMainPane'].getLastSnsMessageId() || 0
      if (command === 'addConfirmMessage') {
        this.$refs['chatMainPane'].addMessage([{
          'snsMessageId': lastSnsMessageId + 10000,
          'snsStaffId': 2,
          'message': '質問メッセージです。\nメッセージは正しく表示されていますか？',
          'distributionType': '1',
          'messageType': '17',
          'sendDate': new Date().getTime()
        }])
      } else if (command === 'addSwitchConfirmMessage') {
        this.$refs['chatMainPane'].addMessage([{
          'snsMessageId': lastSnsMessageId + 10000,
          'snsStaffId': 2,
          'message': '質問メッセージ（スイッチ）です。\nメッセージは正しく表示されていますか？',
          'distributionType': '1',
          'messageType': '19',
          'sendDate': new Date().getTime()
        }])
      } else if (command === 'addImageMessage') {
        this.$refs['chatMainPane'].addMessage([{
          'snsMessageId': lastSnsMessageId + 10000,
          'snsStaffId': 2,
          'distributionType': '1',
          'messageType': '18',
          'messageOption': JSON.stringify({
            'type': 'image',
            'src': './images/sprite.png',
            'to': {
              'type': 'link',
              'url': 'http://fasthelp.jp/'
            }
          }),
          'sendDate': new Date().getTime()
        }])
      } else if (command === 'addButtonListMessage') {
        this.$refs['chatMainPane'].addMessage([{
          'snsMessageId': lastSnsMessageId + 10000,
          'snsStaffId': 2,
          'message': 'ボタン一覧メッセージです。\nメッセージは正しく表示されていますか？',
          'distributionType': '1',
          'messageType': '16',
          'messageOption': JSON.stringify({
            'buttons': [{
                'label': '普通のテキスト',
                'type': 'text'
              },
              {
                'label': '長いテキスト長いテキスト長いテキスト長いテキスト長いテキスト長いテキスト長いテキスト長いテキスト長いテキスト長いテキスト',
                'type': 'text'
              },
              {
                'label': 'fasthelp.jpを別ウィンドウで開きます。',
                'type': 'url',
                'url': 'http://fasthelp.jp/'
              }
            ]
          }),
          'sendDate': new Date().getTime()
        }])
      } else if (command === 'showSuggest') {
        this.$refs['chatMainPane'].showSuggestList(
          ['サジェスト１', 'サジェスト２', 'サジェスト３', 'サジェスト４長目の内容長目の内容長目の内容長目の内容長目の内容長目の内容長目の内容長目の内容長目の内容', 'サジェスト５', 'サジェスト６', 'サジェスト７', 'サジェスト８', 'サジェスト９', 'サジェスト１０'])
      }
    },

    /**
     * Update download status handler
     * @param {string} contentId
     */
    updateDownloadStatusHandler(contentId) {
      if (!contentId) {
        return
      }
      this.sendChatConnection({
        'messageType': ChatMessageConst.MESSAGE_EVENT_TYPE_ATTACH_DOWNLOAD,
        'contentId': contentId
      }).catch(error => {
        console.error(error)
        this.closeChatConnection(true)
      })
    }
  }
}
</script>

<style scoped>
.fc-chat-window {
  height: 100%;
}

.header-area {
  padding: 10px;
  background: #99a9bf;
}

.header-main-area {
  padding: 0px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.header-main-content {
  margin: auto;
}

.close-button-wrapper {
  overflow: hidden;
}

.fc-chat-empty-pane {
  height: auto;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
}

.icoChatTitle,
.header-main-label {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/FcChatWindow.vue